import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  padding-top: 5px;
  padding-bottom: 15px;
  .overlay {
    position: fixed;
  }
`
const Label = styled.label`
  position: absolute;
  top: -11px;
  left: 0px;
  font-size: 12px;
  padding: 0 5px;
`
const ZoneContainer = styled.div`
  border: 1px dashed var(--dark-blue);
  width: 100%;
  min-height: 60px;
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  &.clickable {
    flex-direction: column;
    cursor: pointer;
  }
`
const BoxIntro = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  min-height: 70px;
  padding: 10px;
`
const TextIntro = styled.p`
  text-transform: lowercase;
`
const ErrorMessage = styled.span`
  background: var(--red);
  position: absolute;
  top: 5px;
  right: 0px;
  padding: 0px 5px 2px 5px;
  font-size: 10px;
  display: inline-block;
  font-weight: bold;
  color: #fff;
  border-radius: 0px 5px 0px 5px;
`
const Image = styled.img`
  width: 60px;
`
const Icon = styled(Image)`
  width: 24px;
`
const RemoveButton = styled.button`
  color: var(--red);
  background-color: white;
  padding: 5px;
  display: flex;
  align-items: center;
  span {
    text-transform: lowercase;
    font-weight: 700;
  }
  img {
    width: 16px;
    margin-right: 5px;
  }
`
const ImageBox = styled.div`
  background: #dedede;
  margin: 10px;
`
const BoxButton = styled.div`
  display: flex;
  justify-content: flex-end;
`
const BoxCrop = styled.div`
  background: #dedede;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
const CropButton = styled.button``

export { BoxButton, BoxCrop, BoxIntro, Container, ErrorMessage, Icon, Image, ImageBox, Label, RemoveButton, TextIntro, ZoneContainer }
